import { CREDIT_POOL_ENTRY_TYPES, type CreditPoolEntry } from '@vy/api-definition';
import type { CreditLedgerEntry } from '../CreditsUsageDialog';

export function creditPoolEntriesToLedger(entries: CreditPoolEntry[]): CreditLedgerEntry[] {
  return [...entries]
    .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
    .map((entry) => ({
      id: entry.id,
      date: entry.createdAt,
      // TODO: wire invoiceRef once credit-pool entries carry it (see metadata or a future server field).
      invoiceRef: '',
      credit: entry.type === CREDIT_POOL_ENTRY_TYPES.GRANT ? entry.amount : null,
      debit: entry.type === CREDIT_POOL_ENTRY_TYPES.DEBIT ? entry.amount : null,
      balance: entry.balanceAfter,
      // TODO: wire note from entry.metadata.note (or a dedicated server field) once defined.
      note: null,
      expiryDate: entry.expiryDate,
    }));
}
